export function onlyDigits(s) {
  return (s ?? "").toString().replace(/\D/g, "");
}

// Normaliza para comparação (BR): remove prefixos e reduz para 10/11 dígitos finais
export function normalizePhoneForMatch(v) {
  const d0 = onlyDigits(v);
  if (!d0) return '';

  // remove prefixo de discagem internacional "00"
  const d1 = d0.replace(/^00+/, '');

  // se vier com DDI 55 e tiver tamanho > 11, remove o 55
  const d2 = d1.startsWith('55') && d1.length > 11 ? d1.slice(2) : d1;

  // compara pelos últimos 11 (celular) / 10 (fixo). Aqui usamos 11 como padrão.
  if (d2.length > 11) return d2.slice(-11);

  return d2;
}

const BRAZIL_PREFIX = "55";
const MAX_E164_LENGTH = 15;

function applyBrazilMask(withCountryDigits) {
  let digits = onlyDigits(withCountryDigits);
  if (!digits.startsWith(BRAZIL_PREFIX)) {
    digits = `${BRAZIL_PREFIX}${digits}`;
  }

  digits = digits.slice(0, 13); // +55 (DD) 9xxxx-xxxx

  const country = digits.slice(0, 2);
  const area = digits.slice(2, 4);
  const number = digits.slice(4);

  let result = `+${country}`;

  if (!area) {
    return result;
  }

  if (area.length < 2) {
    return `${result} (${area}`;
  }

  result += ` (${area})`;

  if (!number) {
    return result;
  }

  if (number.length <= 4) {
    return `${result} ${number}`;
  }

  if (number.length <= 8) {
    return `${result} ${number.slice(0, 4)}-${number.slice(4)}`;
  }

  return `${result} ${number.slice(0, 5)}-${number.slice(5, 9)}`;
}

export function formatBrazilianPhone(value) {
  const digitsRaw = onlyDigits(value);
  if (!digitsRaw) return "";

  let digits = digitsRaw;

  // Remove prefixos internacionais comuns "00"
  digits = digits.replace(/^00+/, "");

  if (digits.startsWith(BRAZIL_PREFIX) && digits.length >= 4) {
    return applyBrazilMask(digits);
  }

  const limited = digits.slice(0, MAX_E164_LENGTH);
  return limited ? `+${limited}` : "";
}

export function formatBrazilianPhoneCompact(value) {
  const digitsRaw = onlyDigits(value);
  if (!digitsRaw) return "";

  let digits = digitsRaw.replace(/^00+/, "");

  if (
    digits.startsWith(BRAZIL_PREFIX) &&
    (digits.length === 12 || digits.length === 13)
  ) {
    digits = digits.slice(2);
  }

  if (digits.length === 10 || digits.length === 11) {
    return `${digits.slice(0, 2)} ${digits.slice(2)}`;
  }

  return digits;
}

export function formatPhoneInput(value) {
  const raw = (value ?? "").toString();
  const trimmed = raw.trim();
  const digitsRaw = onlyDigits(raw);

  if (!digitsRaw) {
    if (trimmed.startsWith("+")) return "+";
    if (trimmed.startsWith("00")) return "+";
    return "";
  }

  let digits = digitsRaw;
  const explicitInternational = trimmed.startsWith("+") || trimmed.startsWith("00");

  if (trimmed.startsWith("00")) {
    digits = digits.replace(/^00+/, "");
  }

  if (digits.startsWith(BRAZIL_PREFIX) && digits.length >= 4) {
    return applyBrazilMask(digits);
  }

  if (!explicitInternational) {
    return applyBrazilMask(digits);
  }

  const limited = digits.slice(0, MAX_E164_LENGTH);
  return limited ? `+${limited}` : "+";
}

export function isLikelyValidPhone(value) {
  const digits = onlyDigits(value);
  if (!digits) return true; // vazio é aceitável para não bloquear fluxo
  return digits.length >= 10 && digits.length <= MAX_E164_LENGTH;
}

export function normalizePhoneForApi(value) {
  const raw = (value ?? "").toString().trim();
  if (!raw) return "";

  let digits = onlyDigits(raw);
  if (!digits) return "";

  const explicitInternational = raw.startsWith("+") || raw.startsWith("00");
  if (!explicitInternational) {
    return digits;
  }

  if (raw.startsWith("00")) {
    digits = digits.replace(/^00+/, "");
  }

  return digits ? `+${digits}` : "";
}
